import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.partnerStores
)

export const selectPartnerStoresStatistics = createSelector(
    baseSelector,
    (state) => state.partnersStoresStatistics
)

export const selectPartnerStoresStatisticsLoading = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerStoresStatisticsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerStoresStatisticsError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectCurrentPartner = createSelector(
    baseSelector,
    (state) => state.selectedPartner
)
export const selectStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)